//import { Link } from 'react-router-dom'

const NotFound = () => {
    return ( 
        <div className="not-found">
            <h2>Sorry!</h2>
            <p>404 Not Found!!!</p>
            <link to="/">Go to Home Page...</link>
        </div>
     );
}
 
export default NotFound;